import { render, staticRenderFns } from "./ClosedClaims.vue?vue&type=template&id=3163404f"
import script from "./ClosedClaims.vue?vue&type=script&lang=js"
export * from "./ClosedClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports